import React from 'react'
import { Link } from 'react-router-dom'
import figma from '../../assets/figma.png'
import react from '../../assets/react.png'
import mysql from '../../assets/mysql.png'
import tailwindcss from '../../assets/tailwindcss.png'
import adobexd from '../../assets/adobexd.png'
import js from '../../assets/js.png'
import psd from '../../assets/psd.png'
import php from '../../assets/php.png'

const skills = [
    {
        name: "JavaScript",
        img: js,
        level: "80%",
    },
    {
        name: "ReactJS",
        img: react,
        level: "90%",
    },
    {
        name: "TailwindCSS",
        img: tailwindcss,
        level: "95%",
    },
    {
        name: "PHP",
        img: php,
        level: "75%",
    },
    {
        name: "MySQL",
        img: mysql,
        level: "75%",
    },
    {
        name: "Adobe XD",
        img: adobexd,
        level: "60%",
    },
    {
        name: "Figma",
        img: figma,
        level: "85%",
    },
    {
        name: "Photoshop",
        img: psd,
        level: "75%",
    },
]

const Skills = () => {
    return (
        <div id='skills' className='md:py-[100px] py-[40px] max-w-[1400px] 2xl:mx-auto mx-4'>
            <div className="flex md:flex-row flex-col justify-between items-center gap-8">
                <div className='flex-1'>
                    <div><span className="bg-[#0788ff33] p-2 uppercase rounded-lg">My Skills</span></div>
                    <h2 className="md:text-4xl text-2xl font-bold my-3 uppercase">Let's Explore Popular <br /> <span className='text-secondary'>Skills & Experience</span></h2>
                    <p className='text-darklight'>Discover a wide range of popular skills and experiences that showcase expertise in various domains. From cutting-edge technologies to creative design solutions, explore the capabilities that drive innovation and deliver exceptional results.</p>
                    <div className="my-6"><Link className='bg-secondary rounded-lg py-2 px-6'>Learn More</Link></div>
                </div>
                <div className='grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-6 flex-1'>
                    {skills.map((skill, index) => {
                        return (
                            <div className='flex flex-col px-6 group items-center border border-darklight hover:border-secondary bg-primar gradtop shadow-lg duration-300 shadow-secondary/80 py-6 rounded-xl' key={index}>
                                <img className='w-[64px]' src={skill.img} alt="" />
                                <span className='mt-4 font-medium'>{skill.name}</span>
                                <div className='p-2 w-full text-center mt-2 bg-gray-900 duration-300 group-hover:bg-secondary rounded-xl'>{skill.level}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Skills
